import React, {useState} from 'react';
import {Box, Typography, TextField, Select, MenuItem} from '@mui/material';
import { saveFormDetails } from "../../redux/slices/CreateAgentSlice";
import '../../css/InputDirectoryForm.css'; // Import the CSS file
import { useDispatch, useSelector } from 'react-redux';
import {  FORM_KEYS } from '../../utills/constant';

const InputDirectoryForm = () => {
  const dispatch = useDispatch()
  const formDetails = useSelector((state) => state.CreateAgentSlice.formDetails);
  // The array of directories
  const [directory, setDirectory] = useState([
    { id: 'Azure', name: "Nuvento Blob Storage" } // DO NOT CHANGE
  ]);

  const setFormDetailsValue =(key,value)=>{
    dispatch(saveFormDetails({key,value}))
  }

  // State to track the selected directory's id
  const [selectedDirectory, setSelectedDirectory] = useState("");

  // Handle onChange
  const handleChange = (event) => {
    setSelectedDirectory(event.target.value);
    setFormDetailsValue(FORM_KEYS.INPUT_DIRECTORY_ID,event.target.value)
    
  };

  return (
    <Box className="input-directory-container">
      <h2 className="input-directory-title">INPUT DIRECTORY</h2>

      {/* First Row */}
      <Box className="input-directory-row">
        <Box className="input-directory-column">
          <Typography sx={{color: '#4F4F4F', fontWeight: 'bold'}}>
            Select Directory Provider
          </Typography>
          <Select
            value={formDetails[FORM_KEYS.INPUT_DIRECTORY_ID]}
            onChange={handleChange}
            fullWidth
            displayEmpty
            className="input-directory-select"
          >
            <MenuItem value="" disabled>
              Select a directory
            </MenuItem>
            {directory.map (dir => (
              <MenuItem key={dir.id} value={dir.id}>
                {dir.name}
              </MenuItem>
            ))}
          </Select>
        </Box>

        <Box className="input-directory-column">
          <Typography sx={{color: '#4F4F4F', fontWeight: 'bold'}}>
             URL / PATH
          </Typography>
          <TextField
           value={formDetails[FORM_KEYS.INPUT_DIRECTORY_PATH_OR_ADDRESS]}
            placeholder="Enter URL / PATH"
            fullWidth
            className="input-directory-textfield"
            onChange={(event)=>setFormDetailsValue(FORM_KEYS.INPUT_DIRECTORY_PATH_OR_ADDRESS,event.target.value)}
          />
        </Box>
      </Box>

      {/* Second Row */}
  
      {/* <Box className="input-directory-column">
          <Typography sx={{color: '#4F4F4F', fontWeight: 'bold'}}>
          Bucket name / Container
          </Typography>
          <TextField
            value={formDetails[FORM_KEYS.INPUT_DIRECTORY_BUCKET_NAME]}
            placeholder="Enter Bucket name / Container"
            
            className="input-directory-textfield"
            onChange={(event)=>setFormDetailsValue(FORM_KEYS.INPUT_DIRECTORY_BUCKET_NAME,event.target.value)}
          />
        </Box> */}

        {/* <Box className="input-directory-column">
          <Typography sx={{color: '#4F4F4F', fontWeight: 'bold'}}>
            Access Token
          </Typography>
          <TextField
            placeholder="Enter Access Token"
            value={formDetails[FORM_KEYS.INPUT_DIRECTORY_ACCESS_KEY]}
            fullWidth
            className="input-directory-textfield"
            onChange={(event)=>setFormDetailsValue(FORM_KEYS.INPUT_DIRECTORY_ACCESS_KEY,event.target.value)}
          />
        </Box> */}
  
    </Box>
  );
};

export default InputDirectoryForm;
